import React from "react";
import { Container, Typography } from "@mui/material";

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import NearbyErrorIcon from '@mui/icons-material/NearbyError';
import PasswordIcon from '@mui/icons-material/Password';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';

import { SiteAuthHeader } from "../../components/AuthHeader";
import { AuthPaper } from "../../components/AuthPaper";

import { AuthRegisterForm } from "./Form/Form";
import { useI18n } from "./locales";
import { Helmet } from "react-helmet-async";

export function AuthRegister() {
	const { t } = useI18n();
	return (
		<>
			<Helmet>
				<title>{t('Sign up')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container sx={{maxWidth: "md", pb: 8, pt: 8}}>
					<AuthPaper
						//width={760}
						leftColumn={{
							//width: 340,
							title: t('actions.Create a new Haohan.io account'),
							items: [
								{
									icon: <PermIdentityIcon color='disabled' fontSize='small'/>,
									title: t('instructions.step_1_name')
								},
								{
									icon: <PasswordIcon color='disabled' fontSize='small'/>,
									title: t('instructions.step_2_email')
								},
								{
									icon: <NearbyErrorIcon color='warning' fontSize='small'/>,
									title: t('instructions.step_3_password')
								},
								{
									icon: <MailOutlineIcon color='disabled' fontSize='small'/>,
									title: t('instructions.step_4_activate')
								},
								{
									icon: <CheckCircleOutlineIcon color='success' fontSize='small'/>,
									title: t('instructions.step_5_final')
								},
							]
						}}
						rightColumn={(
							<>
								<Typography
									fontWeight='bold'
									display='block'
									mb={.5}
									textAlign='center'
									variant='h6'
								>
									{t('Sign up')}
								</Typography>
								<AuthRegisterForm/>
							</>
						)}
					/>
				</Container>
			</main>
		</>
	);
}
